import { render, staticRenderFns } from "./FrequencyModal.vue?vue&type=template&id=b5edd8de&"
import script from "./FrequencyModal.vue?vue&type=script&lang=js&"
export * from "./FrequencyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports